// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"8dd471d5","352":"1c9268de","513":"e3d6a80a"}[chunkId] + ".chunk.js";
};